import _ from 'underscore';
import moment from 'moment';

angular.module('am4')
.controller('machineCtrl', function(
    $rootScope,
    $log,
    $state,
    $scope,
    $stateParams,
    machineService,
    errorCodeService,
    errorService,
    orgFacService,
    workoutDataService,
    equipmentGroupService,
    ngDialog,
    machineData,
    serviceRequestService,
    UserService,
    formatDistanceService,
    formatStrengthService) {

    var that = this;

    that.detailData = machineData;
    that.machineUsage = [];
    that.machineUsageLoaded = false;
    that.workouts = [];
    that.workoutsLoaded = false;
    that.recentSnapshots = [];
    that.recentSnapshotsLoaded = false;
    that.errorCodes = [];
    that.errorCodesLoaded = false;
    that.serviceRequests = [];
    that.serviceRequestsLoaded = false;
    that.detailData.time_zone = that.detailData.time_zone || 'UTC';
    that.facility = {};
    that.facilityLoaded = false;

    that.isMassageChair = ['Massage Chair', 'massage_chair'].includes(that.detailData.machine_type_code);

    const dayMilliseconds = 60 * 60 * 24 * 1000,
        threshold = new Date().getTime() - dayMilliseconds;
    that.errorCodeIsWithinOneDay = machineData.error_date && new Date( machineData.error_date ).getTime() >= threshold;

    // Load stats tab data
    workoutDataService.getWorkoutData('daily', {
        start: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        end: moment().subtract(1, 'day').format('YYYY-MM-DD'),
        groups: [
            {
                group: {
                    frame_serial_number: that.detailData.frame_serial
                },
                machines: [
                    {
                        frame_serial_number: that.detailData.frame_serial,
                        facility_id: that.detailData.facility_id
                    }
                ]
            }
        ]
    })
    .then(function(machineUsage) {
        that.machineUsage = machineUsage.data;
        that.detailData.time_zone = machineUsage.timezone;
    })
    .catch(function() {
        // Allow the controller to handle the error
        that.machineUsage = null;
    })
    .finally(function() {
        that.machineUsageLoaded = true;
    });

    // Load workouts (history) tab data
    that.workoutsPromise = machineService.getMachineWorkouts($stateParams.id, 50, 0)
        .then(function(workouts) {
            that.workouts = workouts;
        })
        .catch(function(e) {
            errorService.addError('MACHINE_HISTORY_ERROR', e);
        });

    // Load snapshots tab data
    if ($rootScope.userPermissions.indexOf('EQUIPMENT_ADMIN') > -1) {
        that.recentSnapshots = machineService.getMachineSnapshots($stateParams.id)
            .catch(function(e) {
                errorService.addError('MACHINE_SNAPSHOTS_ERROR', e);
            })
            .finally(function() {
                that.recentSnapshotsLoaded = true;
            });
    }

    // Load events tab data
    errorCodeService.getEquipmentErrorCodes($stateParams.id, null, $rootScope.logged_in_user.user_metadata.am_roles)
    .then(function(errorCodes) {
        that.errorCodes = errorCodes;
    })
    .catch(function(e) {
        errorService.addError('GET_ALERTS_ERROR', e);
    })
    .finally(function() {
        that.errorCodesLoaded = true;
    });

    /*
     // Remove records that have a severity lower than "A".
    function removeLowSeverityRecords(errorRecords) {
        var recordsArr = errorRecords,
        i;

        for (i = recordsArr.length -1; i >= 0; i--) {
            // Get the error code key, via translations.
            const error_code_key = $filter('errorCodeKey')(recordsArr[i].error_code);
            // Get the error's priority, via translations.
            var priority = $translate.instant('ERROR_CODE_' + error_code_key, null, null, 'priority');
            // Remove the item from the array, if it's not an "A" priority.  Iterate backwards to avoid indexing issues.
            if (priority !== 'A') {
                recordsArr.splice(i, 1);
            }
        }

        return recordsArr;
    }*/

    // Load service requests tab data
    if ($rootScope.userPermissions.indexOf('CONNECTED_SERVICE_REQUEST') > -1) {
        serviceRequestService.getServiceRequests($stateParams.id)
        .then(function(res) {
            that.serviceRequests = res.serviceRequests;
        })
        .catch(function(e) {
            $log.error({
                errorMessage: 'GET_SERVICE_REQUESTS_ERROR',
                error: e
            });
        })
        .finally(function() {
            // boolean that disables service request button. Checks if a request has been made in the last day.
            that.recentSubmittedRequest = !!_.find(that.serviceRequests, function(request) {
                return moment(request.created_at).isBetween(moment().subtract(1, 'days'), moment());
            });
            that.serviceRequestsLoaded = true;
        });
    }

    // Load facility information
    that.facility = orgFacService.getFacility(that.detailData.facility_id)
    .then(function(fac) {
        that.detailData.facilityName = fac.name;
        that.detailData.facilityTimeZone = fac.time_zone;
        return fac;
    })
    .catch(function(e) {
        $log.error({
            errorMessage: 'GET_FACILITY_ERROR',
            error: e
        });
    })
    .finally(function() {
        that.facilityLoaded = true;
    });

    that.serial = $state.params.id;
    that.detailData.prettyCreatedAt = moment(that.detailData.discovery_date).format('ll');
    that.detailData.totalDuration = Math.round(moment.duration(+that.detailData.accumulated_time, 'seconds').asHours());

    // works if accumulatedCycles is called accumulated_cycles in workout schema
    that.detailData.totalReps = that.detailData.total_reps;
    that.detailData.totalWeight = that.detailData.total_weight;
    that.detailData.totalWork = that.detailData.total_work;
    that.detailData.totalSessions = that.detailData.total_sessions;


    UserService.user.then(function(user) {
        formatDistanceService.formatDistance(that.detailData, user.unit_preference, that.detailData.modality, true);
        formatStrengthService.formatStrength(that.detailData, user.unit_preference, that.detailData.modality, true);
    });

    equipmentGroupService.getMachineEquipmentGroups(that.detailData.facility_id, that.serial)
    .then(function(res) {
        that.detailData.equipmentGroups = res;
    })
    .catch(function(e) {
        errorService.addError('MACHINE_DETAIL_ERROR', e);
    });

    that.photoCode = $('.am4-detail-hero__picture').width() + 'x' + $('.am4-detail-hero__picture').width(); // eslint-disable-line no-undef

    that.setNaText = function(str) {
        if (_.isNull(str) || _.isUndefined(str) || str.length === 0) {
            return 'N/A';
        }
        return str;
    };

    that.isEqAdminPermission = function() {
        if ($rootScope.userPermissions.indexOf('EQUIPMENT_ADMIN') > -1) {
            return true;
        }
        return false;
    };

    that.hasFacilityLink = function() {
        return $rootScope.userPermissions.indexOf('FACILITY_READ') > -1;
    };

    that.addEquipmentGroup = function() {
        var addEGScope = $scope.$new(),
            dialog;

        equipmentGroupService.getEquipmentGroups(that.detailData.facility_id)
        .then(function(res) {
            addEGScope.groupOptions = [];
            _.each(res, function(group) {
                if (_.isUndefined(_.findWhere(that.detailData.equipmentGroups, {
                    id: group.group_id
                }))) {
                    addEGScope.groupOptions.push(group);
                }
            });
            dialog = ngDialog.open({
                template: require('../views/modal/addEquipmentGroup.html'),
                plain: true,
                scope: addEGScope
            });
        });

        addEGScope.submit = function(newGroupId) {
            addEGScope.isSaving = true;
            equipmentGroupService.addMachineToEquipmentGroup(that.detailData.facility_id, that.serial, newGroupId)
            .then(function(res) {
                addEGScope.isSaving = false;
                that.detailData.equipmentGroups = res;
                dialog.close();
            });
        };
    };

    that.removeEquipmentGroup = function(groupId) {
        var removeEGScope = $scope.$new(),
            dialog = ngDialog.open({
                template: require('../views/modal/removeEquipmentGroup.html'),
                plain: true,
                scope: removeEGScope,
                className: 'ngdialog-theme-plain--danger'
            });

        removeEGScope.submit = function() {
            removeEGScope.isSaving = true;
            equipmentGroupService.removeMachineFromEquipmentGroup(that.detailData.facility_id, that.serial, groupId)
            .then(function(res) {
                removeEGScope.isSaving = false;
                that.detailData.equipmentGroups = res;
                dialog.close();
            });
        };
    };

    that.editName = function() {
        var editScope = $scope.$new();

        editScope.name = that.detailData.nickname || that.serial;
        editScope.renameTranslation = that.detailData.nickname ? 'RENAME_MACHINE' : 'ADD_MACHINE_NAME';

        ngDialog.openConfirm({
            template: require('../views/modal/rename.html'),
            plain: true,
            scope: editScope
        })
        .then(function renameSuccess(newName) {
            return machineService.setMachineNickname(that.serial, newName)
            .then(function(res) {
                that.detailData.nickname = res.nickname;
            })
            .catch(function(e) {
                errorService.addError('UPDATE_NAME_ERROR', e);
            });
        });
    };

    that.toggleActiveState = function() {
        machineService.setMachineActiveState(that.serial, 1 - that.detailData.is_active)
        .then(function(res) {
            that.detailData.is_active = res.is_active;
        })
        .catch(function(e) {
            errorService.addError('TOGGLE_ACTIVE_STATE_ERROR', e);
        });
    };

    that.toggleRemovedState = function() {
        that.removing = true;

        machineService.setMachineRemovedState(that.serial, !that.detailData.is_removed)
        .then(function(res) {
            that.detailData.is_removed = res.is_removed;
        })
        .catch(function(e) {
            errorService.addError('TOGGLE_REMOVED_STATE_ERROR', e);
        })
        .finally(function() {
            that.removing = false;
        });
    };

    $scope.$on('requestSubmitted', function(event, serviceRequests) {
        that.recentSubmittedRequest = true;
        that.serviceRequests = serviceRequests;
    });

    that.requestService = function() {

        ngDialog.open({
            template: require('../views/modal/serviceRequest.html'),
            plain: true,
            controller: 'serviceRequestCtrl as serviceRequestCtrl',
            resolve: {
                machineData: function() { return that.detailData; },
                type: function() { return 'connected'; },
                nonconnected_id: function() { return null; }
            }
        });
    };
});



// WEBPACK FOOTER //
// ./src/app/controllers/machineCtrl.js